import React, { useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { media, BREAK_POINT } from '@Utils/MediaQuery';
import { setSelectedProcessId, setIsUsingPageTabPress, useProcessIdsByValidationPassed } from '@Services/Editor';

import PageItem from './PageItem';

const Page = ({ pageElements, scrollToTargetProcess }) => {
  const dispatch = useDispatch();
  const selectedProcessId = useSelector(({ editor }) => editor.selectedProcessId);
  const processIdsByValidationPassed = useSelector(useProcessIdsByValidationPassed, shallowEqual);

  const handleUpdateSelectedProcessId = useCallback(
    async processId => {
      dispatch(setIsUsingPageTabPress({ isUsingPageTabPress: true }));
      // await scrollToTargetProcess(processId === 0 ? 1 : processId);
      await scrollToTargetProcess(processId === 0 ? 0 : processId);
      dispatch(setSelectedProcessId({ processId }));
      dispatch(setIsUsingPageTabPress({ isUsingPageTabPress: false }));
    },
    [dispatch],
  );
  return (
    <PageContainer>
      {pageElements.map(({ pageId, pageText }) => (
        <PageItem
          key={pageId}
          pageId={pageId}
          pageText={pageText}
          selectedProcessId={selectedProcessId}
          processIdsByValidationPassed={processIdsByValidationPassed}
          handlePageItemPress={handleUpdateSelectedProcessId}
        />
      ))}
    </PageContainer>
  );
};

Page.propTypes = {
  pageElements: PropTypes.arrayOf(PropTypes.shape({ pageId: PropTypes.number, pageText: PropTypes.string })).isRequired,
  scrollToTargetProcess: PropTypes.func.isRequired,
};

const PageContainer = styled.ul`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: calc(100vh - 301px);
  margin: 0px -16px;
  padding: 0px;

  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }

  ${media.lessThan(BREAK_POINT.XS)`
    max-height: 351px;
  `}
`;

export default Page;
